module.exports = __webpack_public_path__ + "img/polymers_video_splash.679718b1.jpg";